import { useEffect } from "react";
import { Redirect, withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSession } from "../../components/Hooks/UserHooks";

const NonAuthLayoutComponent = ({ children }: any) => {
  const { layoutModeType } = useSelector((state: any) => ({
    layoutModeType: state.Layout.layoutModeType,
  }));
  const { session, loading, token } = useSession();

  useEffect(() => {
    if (layoutModeType === "dark") {
      document.body.setAttribute("data-layout-mode", "dark");
    } else {
      document.body.setAttribute("data-layout-mode", "light");
    }
    return () => {
      document.body.removeAttribute("data-layout-mode");
    };
  }, [layoutModeType]);

  if (session && token) {
    return <Redirect to={{ pathname: "/" }} />;
  } else return <div>{children}</div>;
};

export const NonAuthLayout = withRouter(NonAuthLayoutComponent);
